import React from 'react';
import { styled, Tab, Tabs, Tooltip, Typography } from '@mui/material';
import { returnThemeSpacingAsNumber } from '../../../utils/functions';
import Row from '../../../components/Row';
import { InfoOutlined } from '@mui/icons-material';

export interface ChartHeader {
  title: string;
  tabs: string[];
  selectedElement: number;
  setSelectedElement: React.Dispatch<React.SetStateAction<number>>;
  infoData?: string;
}

const ChartHeader: React.FC<ChartHeader> = ({ title, selectedElement, tabs, setSelectedElement, infoData }) => {
  const handleTabChange = (_e: unknown, newValue: number) => {
    setSelectedElement(newValue);
  };

  return (
    <ChartHeaderWrapper testId="chart-header">
      <Row style={{ alignItems: 'center' }}>
        <Typography variant="h6" style={{ fontSize: 16, fontWeight: 500 }}>
          {title}
        </Typography>
        <>
          {infoData && (
            <Tooltip title={infoData} placement="top">
              <InfoOutlined />
            </Tooltip>
          )}
        </>
      </Row>
      <>
        {tabs.length > 1 && (
          <Tabs
            value={selectedElement}
            onChange={handleTabChange}
            data-testid="tabs-wrapper"
            scrollButtons="auto"
            variant="scrollable"
            allowScrollButtonsMobile
          >
            {tabs.map((tab, index) => (
              <Tab label={tab} key={tab} data-testid={`tab-${index}`} />
            ))}
          </Tabs>
        )}
      </>
    </ChartHeaderWrapper>
  );
};

export default ChartHeader;

const ChartHeaderWrapper = styled(Row)(({ theme }) => ({
  backgroundColor: 'white',
  width: '100%',
  height: 'fit-content',
  borderRadius: returnThemeSpacingAsNumber(theme.spacing(0.5)),
  marginBottom: theme.spacing(3),
  alignItems: 'center',
  justifyContent: 'space-between',
  '& svg': {
    marginLeft: theme.spacing(1),
    fontSize: 20,
  },
}));
